angular.module('dialogs')
    .controller('confirmDialogCtrl',
    [
        '$scope', '$modalInstance', 'header', 'msg', 'onYesClick',
        function ($scope, $modalInstance, header, msg, onYesClick) {

            $scope.header = (angular.isDefined(header)) ? header : 'Confirmation';
            $scope.msg = (angular.isDefined(msg)) ? msg : 'Confirmation required.';

            $scope.no = function () {
                $modalInstance.dismiss('no');
            };

            $scope.yes = function () {
                if (onYesClick)
                    onYesClick();
                $modalInstance.close('yes');
            };
        }
    ]);